import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Button from "components/CustomButtons/Button.js";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { NavLink } from "react-router-dom";
import { NumericFormat } from 'react-number-format';

const Card = styled.div`
  border: "0";
  margin-bottom: 0px;
  margin-top: 0.5rem;
  color: white;
  background: #605F70;
  width: "100%";
  box-shadow: 0 1px 4px 0 grey;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0px;
  word-wrap: "break-word";
  font-size: ".875rem";
  border-radius: 6px;
  font-family: "Source Sans Pro",sans-serif;
`;
const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0rem 0.9rem 0rem 0.9rem;
  font-family: "Source Sans Pro",sans-serif;
`;
const CardTitle = styled.h3`
  margin-top: 0.7rem;
  font-size: 1.1rem;
  font-weight: 500;
  font-family: "Source Sans Pro",sans-serif;
`;
const CardSubTitle = styled.button`
  background-color: white;
  border: 0px;
  margin-top: 0.4rem;
  font-size: 1.1rem;
  font-weight: 400;
  color: #3eb462;
`;
const Data = styled.div`
font-size: 14px;
font-weight: 600;
opacity: 1;
`;
const DataResult = styled.div`
  margin-left: auto;
  padding: 0.25rem 1rem;
  font-size: 14px;
  font-weight: 400;
  opacity: 1;
`;
const DataContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0.1rem 1rem;
`;
const DataList = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 0 0.6rem 0;
`;

const navLinkStyle={
  color: '#ffffff',
}

function CustomCardActions(props) {
  return (
    <div>
      <Card>
        <TitleContainer>
          <CardTitle>{props.cardTitle}</CardTitle>
          <NavLink style={navLinkStyle}
              to={`/admin/${props.page}`}
            >
          <VisibilityIcon fontSize="medium" />
            </NavLink>
        </TitleContainer>
        <DataList>
          <DataContainer>
            <Data>{props.dataName1}</Data>
            <DataResult>{props.data1result}</DataResult>
          </DataContainer>
          <DataContainer>
            <Data>{props.dataName2}</Data>
            <DataResult>{props.data2result}</DataResult>
          </DataContainer>
          <DataContainer>
            <Data>{props.dataName3}</Data>
            <DataResult>{props.data3result}</DataResult>
          </DataContainer>
          <DataContainer>
            <Data>{props.dataName4}</Data>
            <DataResult>
            <NumericFormat value={props.data4result} displayType={'text'} thousandSeparator={' '} decimalSeparator={','} suffix={'€'} decimalScale={2} />
            </DataResult>
          </DataContainer>
          <DataContainer>
            <Data>{props.dataName5}</Data>
            <DataResult>{props.data5result}</DataResult>
          </DataContainer>
        </DataList>
      </Card>
    </div>
  );
}

CustomCardActions.propTypes = {
  cardTitle: PropTypes.string,
  dataName1: PropTypes.string,
  data1result: PropTypes.string,
  dataName2: PropTypes.string,
  data2result: PropTypes.string,
  dataName3: PropTypes.string,
  data3result: PropTypes.string,
  dataName4: PropTypes.string,
  data4result: PropTypes.string,
  dataName5: PropTypes.string,
  data5result: PropTypes.string,
  page: PropTypes.string,
};

export default CustomCardActions;
